module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIgMmgzOHYzMS44ODZMMjEgNDUuNjQ4IDIgMzMuODg2VjJ6IiBzdHJva2U9IiNGMUJFNDQiIHN0cm9rZS13aWR0aD0iNCIvPjxwYXRoIGQ9Ik05IDEwbDEyIDcgMTItN005IDE5bDEyIDcgMTItN005IDI4bDEyIDcgMTItNyIgc3Ryb2tlPSIjNEY0RjRGIiBzdHJva2Utd2lkdGg9IjQiLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./components/benefits/hex2.svg
// module id = j+R6
// module chunks = 0